import { render, staticRenderFns } from "./examen.vue?vue&type=template&id=4aec2e20&scoped=true"
import script from "./examen.vue?vue&type=script&lang=js"
export * from "./examen.vue?vue&type=script&lang=js"
import style0 from "./examen.vue?vue&type=style&index=0&id=4aec2e20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aec2e20",
  null
  
)

export default component.exports